import { ReactElement, ReactNode } from 'react';

import { AddCircleIcon, EditIcon } from '@dreryk/react-components';
import { TranslatableText } from '@dreryk/react-common';

import { appointmentTranslationKeys } from '~libs.desktop.shared.appointment';

type LinkProps = {
   icon?: ReactNode;
   label?: TranslatableText | ReactElement;
};

export const getLinkPropsConfiguration = (appointmentNote?: string): Pick<LinkProps, 'icon' | 'label'> => {
   if (appointmentNote) {
      return {
         icon: <EditIcon />,
         label: appointmentTranslationKeys.noteManagement.update.action.label,
      };
   }

   return {
      icon: <AddCircleIcon />,
      label: appointmentTranslationKeys.noteManagement.create.action.label,
   };
};
